import React, { useEffect } from "react";
import { History } from "history";

import { useRootStore } from "store";

interface PageViewTrackerProps {
  history: History;
}

const PageViewTracker: React.FC<PageViewTrackerProps> = ({ history }) => {
  const { userInfo } = useRootStore((state) => state.user);

  useEffect(() => {
    const setupPosthog = async () => {
      if (process.env.REACT_APP_STAGE !== "production") {
        return;
      }

      const posthog = (await import("posthog-js")).default;

      posthog.register({
        userType: userInfo?.type
      });

      const trackPageView = (pathname: string) => {
        posthog.capture("$pageview", {
          path: pathname,
          userType: userInfo?.type
        });
      };

      trackPageView(window.location.pathname);

      const unlisten = history.listen(({ location }) => {
        trackPageView(location.pathname);
      });

      // PAGE LEAVE events commented tue to ticket:
      // https://lrfkonsult.atlassian.net/browse/ML-2240
      // const handlePageLeave = () => {
      //   posthog.capture("$pageleave", {
      //     path: window.location.pathname,
      //     userType: userInfo?.type
      //   });
      // };

      // window.addEventListener("visibilitychange", () => {
      //   if (document.visibilityState === "hidden") {
      //     handlePageLeave();
      //   }
      // });

      // window.addEventListener("beforeunload", handlePageLeave);

      return () => {
        unlisten();
        // window.removeEventListener("visibilitychange", handlePageLeave);
        // window.removeEventListener("beforeunload", handlePageLeave);
      };
    };

    setupPosthog();
  }, [history, userInfo]);

  return null;
};

export default PageViewTracker;
